<li class="row">
  <div class="image col-1">
    <a>
      <i class="file-text-o" aria-hidden="true">
        <img
          class="img-fluid"
          src="./assets/images/icon-article-Abdul-Aziz.png"
          alt="Ícone de artigo"
        />
      </i>
    </a>
  </div>

  <div class="description col-11">
    <a
      class="summaryTitle"
      (click)="redirectArticle()"
      (keydown.enter)="redirectArticle()"
      (keydown.space)="redirectArticle()"
      >{{ articleSummary.titulo }}</a
    >
    <span>{{ articleSummary.META.descricao }}</span
    ><br *ngIf="articleSummary.META.descricao" />
    <a
      class="tag"
      id="tags"
      *ngFor="let tag of articleSummary.marcadores || [] | slice: 0 : 5"
      (click)="redirectTag(tag.nome)"
      (keydown.enter)="redirectTag(tag.nome)"
      (keydown.space)="redirectTag(tag.nome)"
      >{{ tag.nome }}</a
    >
  </div>
</li>
